import React from 'react'

import CompanyProfileModal from '@/components/misc/CompanyProfile/components/CompanyProfileModal'
import EditInvitedCompanyNameModal from '@/components/misc/EditInvitedCompanyNameButton/EditInvitedCompanyNameModal/EditInvitedCompanyNameModal'
import BookMeetingModal from '@/components/modals/BookMeetingModal'
import InviteToRqModal from '@/components/modals/InviteToRqModal/InviteToRqModal'
import PanelInviteModal from '@/components/modals/PanelInviteModal/PanelInviteModal'
import VideoModal from '@/components/modals/VideoModal'
import RecommendedPartnerModalContainer from '@/pages/professionalNetworkRelationships/components/RecommendedPartnerModal/RecommendedPartnerModalContainer'

const CompanyDashboardGlobalModals: React.FC = () => (
  <>
    <InviteToRqModal />
    <VideoModal />
    <BookMeetingModal />
    <RecommendedPartnerModalContainer />
    <CompanyProfileModal />
    <PanelInviteModal />
    <EditInvitedCompanyNameModal />
  </>
)

export default CompanyDashboardGlobalModals
